import { AxiosError } from 'axios'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import * as yup from 'yup'
import { Case } from 'src/api/models'
import { useForm } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import toast from 'react-hot-toast'
import { handleErrorMessage, Notification } from 'src/components/Notification'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface CaseProps {
  num_units: number  //  eslint-disable-line camelcase
  primary_barcode: string  //  eslint-disable-line camelcase
  product: string
}

const caseSchema = yup.object().shape({
  num_units: yup.number().required().label('Number of Units'),
  primary_barcode: yup.string().optional().label('Primary Barcode'),
})

interface Props {
  open: boolean
  productGuid: string
  handleClose: () => void
  onSave?: () => void
  update?: boolean
  productCase?: Case
}

export const CaseDialog = (props: Props) => {
  const { open, handleClose, onSave, update, productCase, productGuid } = props
  const classes = useStyles()

  const onSubmit = (data: CaseProps) => {
    data.product = productGuid
    let func = skuit.sc.cases.create
    let action = 'creat'
    if (update) {
      func = (data: CaseProps) => skuit.sc.cases.patch(productCase?.guid || '', data)
      action = 'updat'
    }
    func(data)
      .then((newCase: Case) => {
        handleClose()
        if (onSave) {
          onSave()
        }
        toast.success(() => (
          <Notification
            message={`Successfully ${action}ed Case with ${newCase.numUnits} units`}
            newObject={newCase}
          />
        ))
      })
      .catch((error: AxiosError) => {
        handleErrorMessage(error, action, 'Case')
        setApiErrors(formData.setError, error)
      })
  }

  const { Form, Field, data: formData } = useForm(caseSchema)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>Create Case</DialogTitle>
        <DialogContent>
          <Field
            name="num_units"
            defaultValue={productCase?.numUnits}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                label="Number of Units"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
          <Field
            name="primary_barcode"
            defaultValue={productCase?.primaryBarcode}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                label="Primary Barcode"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
